import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {

    transform<T>(values: T[], value: any, field?: string, not?: boolean): T[] {
        if (!value) {
            return values;
        }
        if (values) {
            return values.filter(p => {
                let useField = p;
                if (field) {
                    useField = p[field];
                }
                const useFieldResult = (typeof useField === 'function') ? useField() : useField;

                if (not) {
                    if (Array.isArray(value)) {
                        return value.indexOf(useFieldResult) === -1;
                    }
                    return useFieldResult !== value;
                } else {
                    if (Array.isArray(value)) {
                        return value.indexOf(useFieldResult) !== -1;
                    }
                    return useFieldResult === value;
                }
            });
        }
        return null;
    }

}
